import { brotherhoodContent, whyPanama } from '../../data/landingData';
import { MapPin, Compass, Sun, Building } from 'lucide-react';

const iconMap = {
  0: MapPin,
  1: Compass,
  2: Sun,
  3: Building
};

export const Brotherhood = () => {
  return (
    <section 
      id="brotherhood" 
      className="py-24 px-6 bg-[#0A0A0A]"
      data-testid="brotherhood-section"
    >
      <div className="max-w-7xl mx-auto">
        {/* Brotherhood content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
          {/* Text content */}
          <div>
            <p className="text-[#D4AF37] font-manrope uppercase tracking-[0.2em] text-xs font-bold mb-4">
              The Foundation
            </p>
            <h2 className="font-cormorant text-4xl md:text-5xl font-medium text-white mb-8">
              {brotherhoodContent.title}
            </h2>
            <div className="space-y-6">
              {brotherhoodContent.paragraphs.map((paragraph, index) => (
                <p key={index} className="text-zinc-400 font-manrope leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1543807535-eceef0bc6599?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxibGFjayUyMG1lbiUyMGxhdWdoaW5nJTIwdG9nZXRoZXJ8ZW58MHx8fHwxNzc0NzAzOTI0fDA&ixlib=rb-4.1.0&q=85"
                alt="Brotherhood - Black men laughing together"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-4 -left-4 w-32 h-32 border-2 border-[#D4AF37]/30 rounded-2xl -z-10" />
          </div>
        </div>

        {/* Why Panama */}
        <div className="bg-[#111111] rounded-3xl p-8 md:p-12 border border-white/5">
          <div className="text-center mb-12">
            <p className="text-[#D4AF37] font-manrope uppercase tracking-[0.2em] text-xs font-bold mb-4">
              The Destination
            </p>
            <h3 className="font-cormorant text-3xl md:text-4xl font-medium text-white">
              {whyPanama.title}
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {whyPanama.reasons.map((reason, index) => {
              const Icon = iconMap[index];
              return (
                <div 
                  key={index}
                  className="p-6 rounded-xl bg-[#0A0A0A] border border-white/5 hover:border-[#D4AF37]/30 transition-colors group"
                >
                  <Icon className="w-8 h-8 text-[#D4AF37] mb-4 group-hover:scale-110 transition-transform" />
                  <h4 className="font-manrope font-semibold text-white mb-2">{reason.title}</h4>
                  <p className="text-zinc-500 font-manrope text-sm leading-relaxed">{reason.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
